import { render } from "./CallbackPage.vue?vue&type=template&id=81ec295a&scoped=true"
import script from "./CallbackPage.vue?vue&type=script&lang=js"
export * from "./CallbackPage.vue?vue&type=script&lang=js"

import "./CallbackPage.vue?vue&type=style&index=0&id=81ec295a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ec295a"]])

export default __exports__